<template>
  <div class="mv-h-full d-flex flex-column align-center justify-center">
    <div v-if="isGenerated">
      <v-img :src="imageUrl"> </v-img>
    </div>
    <div v-else class="output-container">
      <p class="text-h6 grey--text text--darken-1">还未生成图片</p>
    </div>
  </div>
</template>

<script>
// 这里可以导入其他文件(比如:其他组件,工具JS,json文件,图文件等等)
// Pubsub
import { gallaryIds } from "@/service/wd_pubsub_config.js";
import { subscribe, unsubscribe } from "@/service/wd_pubsub.js";

//例如: import <组件名称> from  <组建路径>

export default {
  //import 引入的组件需要注入到对象中才能使用
  components: {},
  props: {},
  data() {
    //这里存放数据
    return {
      isGenerated: false,
      imageUrl: "",
    };
  },
  //计算机属性 类似与data概念
  computed: {},
  //监控data中数据变化
  watch: {},
  methods: {
    // Pubsub
    pubCallback(msgName, data) {
      if (msgName == gallaryIds.pubId_Local_Image_Generated) {
        this.isGenerated = true;
        this.imageUrl = data;
      }
    },
  },
  //生命周期-创建完成(可以访问当前this实例)
  created() {},
  //生命周期-挂载完成(可以访问DOM元素)
  mounted() {
    subscribe(gallaryIds.pubId_Local_Image_Generated, this.pubCallback);
  },
  destroyed() {
    unsubscribe(this.pubCallback);
  }, //生命周期-销毁完成
  activated() {}, //如果页面有keep-alive,这函数会触发
};
</script>

<style lang="scss"></style>
